import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BleDevice } from '@capacitor-community/bluetooth-le';
import { Directory } from '@capacitor/filesystem';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { StoredSeance } from 'apps/idl/src/anakin/models/StoredSeance';
import { ArrayHelper, ComponentBase, FileHelper, FormHelper, IdHelper, StringHelper } from 'apps/idl/src/helpers';
import { IContact, UserData } from 'apps/idl/src/model';
import { EStatusSeance } from 'apps/idl/src/model/EStatusSeance';
import { ETraitementState } from 'apps/idl/src/model/ETraitementState';
import { ITraitement } from 'apps/idl/src/model/ITraitement';
import { Traitement } from 'apps/idl/src/model/Traitement';
import { ActesService } from 'apps/idl/src/modules/actes/actes.service';
import { FacturationService } from 'apps/idl/src/modules/facturation/facturation.service';
import { EFlagFSE } from 'apps/idl/src/modules/facturation/models/eflag-fse.enum';
import { EInvoiceStatus } from 'apps/idl/src/modules/facturation/models/einvoice-status';
import { IdlPrestation } from 'apps/idl/src/modules/facturation/models/idl-prestation';
import { IFsvErrorSV } from 'apps/idl/src/modules/facturation/models/ifsv-error-sv';
import { Invoice } from 'apps/idl/src/modules/facturation/models/invoice';
import { FilesystemService } from 'apps/idl/src/modules/filesystem/services/filesystem.service';
import { ITerminal } from 'apps/idl/src/modules/olaqin/models/iterminal';
import { ITerminalInfo } from 'apps/idl/src/modules/olaqin/models/iterminal-info';
import { OlaqinService } from 'apps/idl/src/modules/olaqin/services/olaqin.service';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { AMOP } from 'apps/idl/src/modules/patients/model/amo-p';
import { EUpdateMode } from 'apps/idl/src/modules/patients/model/eupdate-mode.enum';
import { CouverturesService } from 'apps/idl/src/modules/patients/services/couvertures.service';
import { EPrestationStatus } from 'apps/idl/src/modules/prestation/models/eprestation-status.enum';
import { PrestationService } from 'apps/idl/src/modules/prestation/services/prestation.service';
import { ContactsService, PlatformService, Store } from 'apps/idl/src/services/security';
import { TraitementService } from 'apps/idl/src/services/traitement.service';
import { CapacitorPluginScePlugin } from 'capacitor-plugin-sce';
import { StatusSCEPlugin } from 'capacitor-plugin-sce/src/interfaces/StatusSCEPlugin';
import { EMPTY, Observable, Subscription, defer, from, iif, of, throwError } from 'rxjs';
import { catchError, concatMap, delay, filter, finalize, map, mergeMap, switchMap, take, takeUntil, tap, timeout, toArray } from 'rxjs/operators';
import { EModeSecurisation } from '../../../../../modules/facturation/models/emode-securisation.enum';
import { IAccordPrealable } from '../../../../../modules/patients/model/IAccordPrealable';
import { AMCP } from '../../../../../modules/patients/model/amc-p';
import { IAMC } from '../../../../../modules/patients/model/iamc';
import { IAMO } from '../../../../../modules/patients/model/iamo';
import { SceService } from '../../../../../modules/sce/services/sce.service';
import { AccordPrealableService } from '../../../../../modules/traitement/slides-traitement/accordPrealable/accordPrealable.service';
import { C_PREFIX_TERMINAL } from '../../../../anakin.constants';
import { SceEventService } from '../../../sce4Mobile/sce-event.service';
import { SceStatus } from '../../../sce4Mobile/sce-status';
import { SceFactory } from '../../../sce4Mobile/sceFactory';
import { ConfirmationImpressionComponent } from '../../../shared/components/confirmation-impression/confirmation-impression.component';
import { ECerfa } from '../../../shared/enums/ECerfa';
import { EDeviceType } from '../../../shared/enums/EDeviceType';
import { EModeFacturation } from '../../../shared/enums/EModeFacturation';
import { EModule } from '../../../shared/enums/EModule';
import { ETypeLecteur } from '../../../shared/enums/ETypeLecteur';
import { BluetoothService } from '../../../shared/services/bluetooth.service';
import { DeviceService } from '../../../shared/services/device.service';
import { DrawerPopoverService } from '../../../shared/services/drawer-popover.service';
import { FacturationSVService } from '../../../shared/services/facturation-sv.service';
import { LecteurStorageService } from '../../../shared/services/lecteurStorage.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { PanneauService } from '../../../shared/services/panneau.service';
import { SeanceService } from '../../../shared/services/seance.service';
import { SeancesGeneratorService } from '../../../shared/services/seances-generator.service';
import { SnackbarService } from '../../../shared/services/snackbar.service';

interface IFspItem {
  blob: Blob;
  name: string;
  url: string;
}

@Component({
  selector: 'di-facturation-sv',
  templateUrl: './facturation-sv.component.html',
  styleUrls: ['./facturation-sv.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FacturationSvComponent extends ComponentBase implements OnInit, OnDestroy {
  @Input() public seancesAFacturer: StoredSeance[] = [];
  @Input() public seances: StoredSeance[] = [];
  @Input() public invoice: Invoice = null;
  @Input() public ordonnance: ITraitement;
  @Input() public patient?: IPatient;
  @Input() public couvertureAMO?: IAMO;
  @Input() public couvertureAMC?: IAMC;
  @Input() public couvertureAMCPatient?: AMCP;
  @Input() public titulaireSelected?: IContact;
  @Input() public mode: EModeFacturation = EModeFacturation.SV;
  @Input() public closeButton?: boolean = false;

  public prestations: IdlPrestation[] = [];

  private readonly MSG_FACTURATION_DEGRADEE: string = "La facturation est dégradée car vous n'aviez pas la carte Vitale du patient ou une donnée a été modifiée manuellement dans la couverture du patient. Vous devez envoyer la feuille de soins.";
  public sousTexteFacturationOk = "Une feuille de soin électronique a été générée, ainsi qu'une DRE pour la mutuelle. Vous devrez les envoyer via le module SESAM-Vitale";
  public titreFacturationOk = "Facturation terminée";
  public iconeFacturationOk = "check_circle";

  public facturationTerminee: boolean = false;
  public erreurFacturation: boolean = false;
  public titreErreur = "Une erreur est survenue";
  public messageErreur: string = "";
  public readonly terminalId$: Observable<string>;
  public terminal?: ITerminalInfo;
  public canValidate: boolean = false;
  public facturationEnCours: boolean = false;

  public terminalError: boolean = false;
  public cpsError: boolean = false;
  public vitaleError: boolean = false;
  public lastTerminalId: string;
  public tarificationTerminee: boolean = false;
  public securisationTerminee: boolean = false;
  public noSecurisation: boolean = false;
  public carteVitaleAbsente: boolean = false;
  public noLecteur: boolean = false;
  public carteCPSAbsente: boolean = false;
  public chargementLecteur: boolean = false;
  public textChargementLecteur: string = "Chargement des informations du lecteur...";
  public isMobile: boolean = true;
  public listTerminal: ITerminal[] = [];
  public isSelected: boolean = false;
  public isReady: boolean = false;
  public showPopover: boolean = false;

	public demandeCodeCPS : boolean = false;
	public cpsSaisie : string = "";
  public selectionTerminal = false;
	public errorCodeShow : boolean = false;
	public errorCodeMessage : string = "";

  public erreurLecteurSCE = false;
  public titreErreurSCE = "";
  public messageErreurSCE = "";

  
  public lecteurName: string;
  private sceStatusSubscription?: Subscription;

  constructor(
    private svcOlaqin: OlaqinService,
    public changeDetector: ChangeDetectorRef,
    private svcDrawerPopover: DrawerPopoverService,
    private readonly svcPrestation: PrestationService,
    private svcSnackbar: SnackbarService,
    private svcSeanceGenerator: SeancesGeneratorService,
    private svcTraitement: TraitementService,
    private svcPanneau: PanneauService,
    private readonly svcFacturation: FacturationService,
    private readonly svcFilesystem: FilesystemService,
    private readonly ioFileOpener: FileOpener,
    private readonly svcDevice: DeviceService,
    private readonly svcSeance: SeanceService,
    private router: Router,
    private svcAccordPrealable: AccordPrealableService,
    private svcStore: Store,
    private psvcPlatform: PlatformService,
		private svcSCE : SceService,
		private svcContact : ContactsService,
    private svcActes: ActesService,
    private svcFacturationSV: FacturationSVService,
    private svcCouvertures: CouverturesService,
    private svcLoader: LoaderService,
    private svcSceEvent : SceEventService,
    private svcLecteurStorage : LecteurStorageService,
    private svcBluetooth: BluetoothService,
		private svcPlatform : PlatformService
  ) {
    super(changeDetector);
    this.terminalId$ = this.svcOlaqin.getLastUsedTerminalId(true).pipe(takeUntil(this.destroyed$));
  }

	public pluginSce : CapacitorPluginScePlugin;
	

  navigateToOrdonnance() {
    this.svcDrawerPopover.close();
    this.svcPanneau.close();
    this.router.navigate(["facturation"]);
  }

  public ngOnInit() {

		const deviceTypeUser: EDeviceType = this.svcPlatform.getDeviceType();
		this.pluginSce = SceFactory.getSceInstance(deviceTypeUser)

    this.svcDevice.isMobile$.pipe(takeUntil(this.destroyed$)).subscribe((flag: boolean) => {
      this.isMobile = flag;
    });

    if (this.mode === EModeFacturation.PAPIER) {
      this.facturerPapier();
      return;
    }
    this.getListTerminal();
  }

  public override ngOnDestroy() {
    if (UserData.modules.includes(EModule.sce) && this.psvcPlatform.isMobileApp) {
      if (this.sceStatusSubscription) {
				this.sceStatusSubscription.unsubscribe();
			}
      from(this.pluginSce.getStatus()).pipe(
        switchMap((status: StatusSCEPlugin) => {
          if (status.connected) {
            return from(this.pluginSce.disconnect());
          }
          return EMPTY;
        })
      ).subscribe();
    }
    super.ngOnDestroy();
  }

  public getListTerminal(): void {
    this.svcContact.getContact(ContactsService.getContactIdFromUserId(UserData.current._id)).pipe(
      switchMap((contact: IContact | null) => {
        this.svcLoader.showLoader("Récupération des lecteurs disponibles...")
        if (UserData.modules.includes(EModule.sce)) {
          if (!contact?.finess) {
            this.svcSnackbar.showToast(
              "error",
              "bottom center",
              "Le n° FINESS du praticien n'est pas défini.",
              null,
              null,
              null,
              "7000"
            );
            return EMPTY;
          }
          return this.svcSCE.listTerminals(contact.finess, contact.rpps ?? contact.adeli ?? "");
        }
        return this.svcOlaqin.listTerminals();
      }),
      tap((list: ITerminal[]) => {
        this.svcLoader.hideLoader();
        this.listTerminal = list;
        if (UserData.modules.includes(EModule.sce)) {
          const lastUsedTerminal = this.listTerminal.find(terminal => terminal.lastUsed === true);
          if (lastUsedTerminal) {
            this.lastTerminalId = lastUsedTerminal.terminalId;
            this.terminal = lastUsedTerminal
          }
					if (this.lastTerminalId && this.lastTerminalId !== '') {
						this.isSelected = true;
						this.onSelectTerminal(this.terminal);
					}
        } else {
          this.svcOlaqin.getLastUsedTerminalId().pipe(
            tap((terminalId: string) => {
              const termId = IdHelper.getGuidFromId(terminalId, C_PREFIX_TERMINAL) || ''
              this.terminal = this.listTerminal.find(term => term.terminalId === termId);
              this.lastTerminalId = this.terminal ? this.terminal.terminalId : "";
            })
          ).subscribe(() => {
            if (this.lastTerminalId !== '') {
              this.isSelected = true;
							this.onSelectTerminal(this.terminal);
            }
            this.detectChanges();
          });
          return;
        }
        
        this.detectChanges();
      }),
      catchError((error) => {
        this.svcLoader.hideLoader();
        return error
      }),
      takeUntil(this.destroyed$)
    ).subscribe();
  }

  public isLastTerminal(terminal: ITerminal): boolean {
    return this.lastTerminalId === terminal.terminalId;
  }

  private isTerminalReady(): boolean {
    this.terminalError = false
    this.cpsError = false
    this.vitaleError = false
    if (this.mode === EModeFacturation.DEGRADE) {
      this.carteVitaleAbsente = true;
    }
    return this.terminal?.terminalConnected && (this.terminal?.cpsInserted || this.carteCPSAbsente) && (this.terminal?.vitaleInserted || this.carteVitaleAbsente);
  }

  public async onSelectTerminal(terminal?: ITerminal) {
    this.isReady = false;
    this.noLecteur = false;
    this.carteCPSAbsente = false;
    this.carteVitaleAbsente = false;
		this.isSelected = true;
    this.selectionTerminal = false;
    this.chargementLecteur = false;

    if(terminal){
      this.lastTerminalId = terminal.terminalId;
      this.terminal = terminal;
    }
    
		if(this.terminal.type === ETypeLecteur.OLAQIN 
      || this.terminal.type === ETypeLecteur.PIRANHA 
      || (this.terminal.type === ETypeLecteur.SCE && this.terminal.device !== EDeviceType.ANDROID && this.terminal.device !== EDeviceType.IOS)){
			this.onReadyLecteur();
		} else {
			if (this.terminal.type === ETypeLecteur.SCE && (this.terminal.device === EDeviceType.ANDROID && this.psvcPlatform.isAndroid) || (this.terminal.device === EDeviceType.IOS && this.psvcPlatform.isIOS)) {
        this.svcLoader.showLoader("Recherche du lecteur Bluetooth...");
        this.listenToSceStatus();
				const sceStatus = await this.pluginSce.getStatus()
        iif(() => !sceStatus.connected && !sceStatus.connecting,
          defer(() => {
            this.svcLoader.showLoader("Connexion avec le SCE Mobile en cours ...");
            console.warn('[COMP] Connexion au SCE en cours...');
            return from(this.pluginSce.connect());
          }),
          defer(() => {
            this.retrySce();
            this.svcLoader.showLoader("Déconnexion du SCE Mobile en cours...");
            console.warn('[COMP] Déconnexion du SCE en cours...');
            return from(this.pluginSce.disconnect());
          })
		    ).pipe(
					takeUntil(this.destroyed$),
          catchError((err) => {
            this.svcLoader.hideLoader();
            console.error('[COMP] Erreur lors du connectToSCE initial', err);
            this.svcSceEvent.emitStatus('error');
            return EMPTY
          })
        ).subscribe();
			}
		}
  }

  public retrySce(): void {
      this.svcSceEvent.sceDisconnect$.pipe(
        take(1),
        takeUntil(this.destroyed$),
        tap(() => {
          this.svcLoader.showLoader("Connexion avec le SCE Mobile en cours ...")
          console.warn('[COMP] Connexion au SCE en cours...');
        }),
        concatMap(() => from(this.pluginSce.connect())),
        timeout(15000), 
          catchError(error => {
              this.svcLoader.hideLoader();
              this.svcSnackbar.showToast("error", "bottom center", "Erreur lors de la connexion au lecteur, veuillez réessayer.", null, null, null, "6000");
              this.svcDrawerPopover.close();
              this.svcPanneau.close();
              console.error('Timeout: aucune réponse après 15 secondes');
              return of(null); 
            }
          )
      ).subscribe();
    }

  public onReadyLecteur(): void {
    this.chargementLecteur = true;
    this.isReady = true;
    this.detectChanges();
		const terminalInfo$ = StringHelper.isBlank(this.lastTerminalId)
            ? of({} as ITerminalInfo)
            : UserData.modules.includes(EModule.sce) 
						? this.svcSCE.getTerminalInfos(this.terminal)
						: this.svcOlaqin.getTerminalInfos(this.lastTerminalId);

    terminalInfo$.pipe(
      takeUntil(this.destroyed$),
      catchError((error) => {
        this.chargementLecteur = false;
        const message = "Une erreur est survenue lors du test de presence carte dans le lecteur.";
				this.terminalError = !this.terminal?.terminalConnected;
				this.cpsError = !this.terminal?.cpsInserted;
				this.vitaleError = !this.terminal?.vitaleInserted;
				this.svcSnackbar.showToast(
					"error",
					"bottom center",
					message,
					null, null, null, "5000"
				);
				this.detectChanges();
				return EMPTY;
      }),
      switchMap((terminal: ITerminalInfo) => {
        this.chargementLecteur = false;
        if(terminal){
          this.terminal.terminalConnected = terminal.terminalConnected;
          this.terminal.vitaleInserted = terminal.vitaleInserted;
          this.terminal.cpsInserted = terminal.cpsInserted;
          this.canValidate = this.isTerminalReady();
          this.detectChanges();
          if (this.canValidate) {
            this.facturationEnCours = true;
            this.detectChanges();
            return of(true);
          } else {
            this.facturationEnCours = false;
            this.terminalError = !this.terminal?.terminalConnected;
            this.cpsError = !this.terminal?.cpsInserted;
            this.vitaleError = !this.terminal?.vitaleInserted;
            this.detectChanges();
            return EMPTY;
          }
        }else{
          this.facturationEnCours = false;
          this.terminalError = true;
          this.detectChanges();
          return EMPTY;
        }
      }),
			mergeMap(() => UserData.modules.includes(EModule.sce) ? of(true) : this.svcOlaqin.setLastUsedTerminalId(this.lastTerminalId)),
      // Valide et facture toutes les prestations
      switchMap(() => {
        return this.mode === EModeFacturation.DEGRADE
          ? this.processFacturationDegradee() :
          this.invoice ? this.processFacturationWithInvoice() : this.processFacturation();
      }),
      catchError((error) => {
        if (this.canValidate) {
          console.error('Erreur lors du process de facturation:', error);
          this.erreurFacturation = true;
          this.tarificationTerminee = true;
          this.facturationTerminee = true;
          this.messageErreur = error?.error?.message || error?.error?.error || error.message;
          this.titreErreur = "Une erreur est survenue";
        } else {
          this.terminalError = !this.terminal?.terminalConnected;
          this.cpsError = !this.terminal?.cpsInserted;
          this.vitaleError = !this.terminal?.vitaleInserted;
        }
        this.facturationEnCours = false;
        this.detectChanges();
        return EMPTY;
      })
    ).subscribe()
  }

  private processFacturationDegradee(): Observable<any> {
    let invoiceBddCopy: Invoice = null;
    this.tarificationTerminee = true;
    this.detectChanges();
    return this.svcFacturation.getInvoice(this.invoice._id).pipe(
      tap((invoice: Invoice) => invoiceBddCopy = invoice),
      mergeMap(() => this.facturationDegradee(this.invoice, EModeSecurisation.DEGRADE)),
      tap((invoices: Invoice[]) => {
        const invoiceEnCours: Invoice = ArrayHelper.getFirstElement(invoices);
        this.majFacture(invoiceEnCours);
        this.detectChanges();
      }),
      switchMap(() => this.securisationDegradee(this.invoice, EModeSecurisation.DEGRADE, this.terminal)),
      tap((invoices: Invoice[]) => {
        const invoiceEnCours: Invoice = ArrayHelper.getFirstElement(invoices);
        this.majFacture(invoiceEnCours);
        this.detectChanges();
      }),
      switchMap(() => this.consulterFactureDegradee(this.invoice)),
      tap((invoice: Invoice) => {
        //Si tout s'est bien passé on retire l'erreur de la facture
        delete invoice.erreurFacturation;
        this.majFacture(invoice);
        this.detectChanges();
      }),
      catchError((error) => {
        //Il faut annuler la facture coté IE
        this.svcFacturation.annulerFacturePreparee(this.invoice);

        //On récupère la rev de la dernière invoice en bdd
        invoiceBddCopy._rev = this.invoice._rev;
        //TODO : en cas de probleme de conflit, on peut faire ça et supprimer la facture
        // delete invoiceCopy._rev;

        //On enregistre le message d'erreur dans la facture
        invoiceBddCopy.erreurFacturation = error?.error?.message ?? "Une erreur inconnue est survenue lors de la facturation.";

        //On remet le mode de sécurisation d'origine 
        invoiceBddCopy.securisationMode = EModeSecurisation.SECURISE;

        this.majFacture(invoiceBddCopy);
        return of(null);
      }),
      finalize(() => {
        //On enregistre la facture
        this.svcFacturation.saveInvoice(this.invoice).subscribe(); // déclenche le trigger invoiceChange 
        // this.svcFacturation.saveInvoices([this.invoice]).subscribe(); // déclenche pas le trigger invoiceChange, à voir en fonction des retours prod
        //On déclenche le trigger qui permet de passer a la facture suivante
        this.svcFacturationSV.triggerInvoiceProcessed(this.invoice, !this.invoice.erreurFacturation);
      })
    );
  }

  public facturationDegradee(invoice: Invoice, modeSecurisation: EModeSecurisation): Observable<Invoice[]> {
    return from(this.svcFacturationSV.callFacturationApi(invoice, modeSecurisation));
  }

  public securisationDegradee(invoice: Invoice, modeSecurisation: EModeSecurisation, terminal: ITerminalInfo): Observable<Invoice[]> {
    return from(this.svcFacturationSV.callSecurisationApi(invoice, modeSecurisation, terminal));
  }

  public consulterFactureDegradee(invoice: Invoice) {
    return from(this.svcFacturation.consulterFacture(invoice, true));
  }

  private getPatientCouvertures(invoice: Invoice) {
    return this.svcCouvertures.getPatientSortedCouvertures(this.patient._id, false)
      .pipe(
        tap((poCouvertures: { AMOPs: AMOP[]; AMCPs: AMCP[] }) => {
          // AMO active du patient
          const dates = invoice.actes?.map(a => new Date(a.date)) || [];
          this.patient.AMO = [poCouvertures.AMOPs.find(x => this.svcCouvertures.areAllDatesEligible(x, dates))];

          // AMC active du patient
          this.patient.AMC = [poCouvertures.AMCPs.find(x => this.svcCouvertures.areAllDatesEligible(x, dates))];
        }),
      )
  }

  private processFacturationWithInvoice(): Observable<any> {
    let invoiceBddCopy: Invoice = null;

    return this.svcFacturation.getInvoice(this.invoice._id).pipe(
      tap((invoice: Invoice) => invoiceBddCopy = invoice),
      switchMap(() => {
        if (this.carteCPSAbsente) {
          this.invoice.securisationMode = EModeSecurisation.PAPIER;
          return this.svcFacturation.saveInvoices([this.invoice]);
        } else {
          return this.getPatientCouvertures(this.invoice);
        }
      }),
      switchMap(() => this.psvcPlatform.isMobileApp && this.carteCPSAbsente ? this.svcStore.replicateSingleDocument(this.invoice._id) : of(true)),
      mergeMap(() => {
        return this.facturation(invoiceBddCopy);
      }),
      tap((invoice: Invoice) => {
        this.majFacture(invoice);
        this.detectChanges();
      }),
      switchMap(() => this.psvcPlatform.isMobileApp ? this.svcFacturation.saveInvoices([this.invoice]) : of(true)),
      switchMap(() => this.psvcPlatform.isMobileApp ? this.svcStore.replicateSingleDocument(this.invoice._id) : of(true)),
      //On sécurise la facture dans Intellio editeur (pour les modes de sécurisation DEGRADEE et SV)
      mergeMap(() => {
        if (this.invoice.securisationMode === EModeSecurisation.PAPIER) return of(this.invoice);
        return this.securisation(invoiceBddCopy);
      }),
      tap((invoice: Invoice) => {
        this.majFacture(invoice);
        this.detectChanges();
      }),
      switchMap((invoice: Invoice) =>
        this.shouldCallConsulterFacture(invoice)
          ? from(this.svcFacturation.consulterFacture(invoice))
          : of(invoice)
      ),
      tap((invoice: Invoice) => {
        //Si tout s'est bien passé on retire l'erreur de la facture
        delete invoice.erreurFacturation;
        this.majFacture(invoice);
        this.showMessageFacturationOK();
      }),
      mergeMap(() => {
        if (this.invoice.securisationMode === EModeSecurisation.PAPIER) {
          //facturation papier, on doit maj le statut de l'invoice car on n'exporte plus la facture dans intellio editeur
          this.invoice.status.value = this.invoice.totalPartPatient > 0 ? EInvoiceStatus.payment : EInvoiceStatus.closed;
          // return this.svcFacturation.saveInvoices([this.invoice]);
        }
        return of(null);
      }),
      catchError((error) => {
        //Il faut annuler la facture coté IE
        this.svcFacturation.annulerFacturePreparee(this.invoice);

        //On récupère la rev de la dernière invoice en bdd
        invoiceBddCopy._rev = this.invoice._rev;
        //On enregistre le message d'erreur dans la facture
        invoiceBddCopy.erreurFacturation = error?.error?.message ?? "Une erreur inconnue est survenue lors de la facturation.";

        //On remet le mode de sécurisation d'origine 
        invoiceBddCopy.securisationMode = EModeSecurisation.SECURISE;

        this.majFacture(invoiceBddCopy);
        return of(null);
      }),
      finalize(() => {
        //On enregistre la facture
        this.svcFacturation.saveInvoice(this.invoice).subscribe(); // déclenche le trigger invoiceChange
        //On met a jour la pastille du menu	
        this.svcFacturationSV.updateFacturesPrepareesBadgeCount().subscribe();
      })
    );
  }

  private shouldCallConsulterFacture(invoice: Invoice): boolean {
    return invoice?.securisationMode === EModeSecurisation.DEGRADE ||
      invoice?.securisationMode === EModeSecurisation.SECURISE;
  }

  private showMessageFacturationOK() {
    if (this.invoice.securisationMode === EModeSecurisation.DEGRADE) {
      this.titreFacturationOk = "Facturation dégradée";
      this.sousTexteFacturationOk = this.MSG_FACTURATION_DEGRADEE;
    } else if (this.invoice.securisationMode === EModeSecurisation.SECURISE) {
      this.getSousTexteFacturationSecurise();
      this.titreFacturationOk = "Facturation terminée";
    } else if (this.invoice.securisationMode === EModeSecurisation.PAPIER) {
      this.titreFacturationOk = "Facturation papier";
      this.sousTexteFacturationOk = "La facturation est au format papier car vous n'aviez pas votre carte CPS. Il n'aura pas de feuille soins électronique. Vous devez envoyer la feuille de soins manuellement.";
    }
    this.facturationTerminee = true;
    this.messageErreur = "";
    this.titreErreur = "";
    this.erreurFacturation = false;
    this.titreErreurSCE = "";
    this.messageErreurSCE = "";
    this.erreurLecteurSCE = false;
    this.facturationEnCours = false;
    this.detectChanges();
  }

  private getSousTexteFacturationSecurise() {
    const flagInvoice: EFlagFSE = this.invoice.securisationData?.flag;
    let premierePartieTxt: string = "";
    switch (flagInvoice) {
      case EFlagFSE.DRE:
        premierePartieTxt = "Une demande de remboursement électronique (DRE) a été générée. Vous devrez l'";
        break;
      case EFlagFSE.FDE:
        premierePartieTxt = "Une feuille de soins électronique a été générée, ainsi qu'une DRE pour la mutuelle. Vous devrez les ";
        break;
      default:
        //FSE, FSU, ENR
        premierePartieTxt = "Une feuille de soins électronique a été générée. Vous devrez l'";
        break;
    }

    this.sousTexteFacturationOk = [premierePartieTxt, "envoyer via le module SESAM-Vitale."].filter(Boolean).join("");
  }

  private processFacturation(): Observable<any> {
    return this.validateAndBillPrestations().pipe(
      // Créer une seule Invoice pour toutes les prestations
      tap((prestations) => {
        this.prestations = prestations;  // On s'assure que toutes les prestations sont présentes
        const invoice = this.createInvoice();
        if (this.carteCPSAbsente) {
          invoice.securisationMode = EModeSecurisation.PAPIER;
        }
        this.invoice = invoice;
      }),
      // Rempli l'Invoice avec des informations des sts et gu
      tap(() => {
        const amc = this.patient.AMC?.find(x => this.svcCouvertures.isEligibleFacturationFromPrestations(x, this.prestations));
        this.svcFacturation.fillInvoiceSTSAndGU(this.invoice, amc);
      }),
      // Sauvegarde l'Invoice
      switchMap(() => this.svcFacturation.saveInvoice(this.invoice)),
      // Sauvegarde des prestations
      switchMap((invoice) => {
        this.invoice = invoice;
        this.prestations.forEach((x) => x.status = EPrestationStatus.sent);
        return this.svcPrestation.savePrestations(this.prestations);
      }),
      switchMap(() => this.psvcPlatform.isMobileApp ? this.svcStore.replicateSingleDocument(this.invoice._id) : of(true)),

      // Lance la tarification (dans tous les modes de sécurisation DEGRADEE, PAPIER et SV)
      switchMap(() => {
        return this.tarification();
      }),
      switchMap((invoice) => this.verifierErreurSV(invoice)),
      tap((invoice) => {
        this.invoice = invoice;
        this.tarificationTerminee = true;
        this.detectChanges();
      }),
      switchMap(() => this.psvcPlatform.isMobileApp ? this.svcFacturation.saveInvoice(this.invoice).pipe(
        tap((invoice) => {
          this.majFacture(invoice);
          this.detectChanges();
        }),
        switchMap(() => this.svcStore.replicateSingleDocument(this.invoice._id))
      ) : of(true)),
      //On exporte la facture dans Intellio editeur (pour les modes de sécurisation DEGRADEE et SV)
      mergeMap(() => {
        return this.facturation();
      }),
      tap((invoice: Invoice) => {
        this.majFacture(invoice);
        this.detectChanges();
      }),
      switchMap(() => this.psvcPlatform.isMobileApp ? this.svcFacturation.saveInvoice(this.invoice).pipe(
        tap((invoice) => {
          this.majFacture(invoice);
          this.detectChanges();
        }),
        switchMap(() => this.svcStore.replicateSingleDocument(this.invoice._id))
      ) : of(true)),
      //On sécurise la facture dans Intellio editeur (pour les modes de sécurisation DEGRADEE et SV)
      mergeMap(() => {
        return this.securisation();
      }),
      switchMap((invoice: Invoice) =>{
        if (invoice && (invoice.securisationMode === EModeSecurisation.DEGRADE || invoice.securisationMode === EModeSecurisation.SECURISE)) {
          return from(this.svcFacturation.consulterFacture(invoice));
        } else {
          return of(invoice);
        }
      }),
      tap((invoice: Invoice) => {
        this.majFacture(invoice);
        this.showMessageFacturationOK();
      }),
      mergeMap(() => {
        // On récupère toutes les séances "done" et on les prépare pour l'update
        const seancesToUpdate = this.seancesAFacturer
          .filter(seance => seance.status === EStatusSeance.done)
          .map(seance => {
            seance.status = EStatusSeance.completed;
            return seance;
          });

        // On fait un seul appel pour tout mettre à jour
        return seancesToUpdate.length > 0
          ? this.svcSeance.updateSeances(seancesToUpdate)
          : of(null);
      }),
      mergeMap(() => {
        if (this.invoice.securisationMode === EModeSecurisation.PAPIER) {
          //facturation papier, on doit maj le statut de l'invoice car on n'exporte plus la facture dans intellio editeur
          this.invoice.status.value = this.invoice.totalPartPatient > 0 ? EInvoiceStatus.payment : EInvoiceStatus.closed;
          return this.svcFacturation.saveInvoices([this.invoice]);
        }
        return of(EMPTY);
      })
    )
  }

  public facturerPapier() {
    this.initEtatFacturationPapier();

    const facturation$ = this.getFluxFacturation();
    facturation$.subscribe();
  }

  private initEtatFacturationPapier(): void {
    this.carteCPSAbsente = true;
    this.carteVitaleAbsente = true;
    this.erreurFacturation = false;
    this.erreurLecteurSCE = false;
    this.tarificationTerminee = false;
    this.facturationTerminee = false;
    this.facturationEnCours = true;
    this.securisationTerminee = false;
    this.noSecurisation = true;

    this.isReady = true;
    this.canValidate = true;
    this.messageErreur = "";
    this.detectChanges();
  }

  private getFluxFacturation(): Observable<any> {
    //Facturation dégradée en masse (factures préparées)
    if (this.mode === EModeFacturation.DEGRADE) {
      return this.processFacturationDegradee();
    }

    //Facturation depuis la carte facturation preparée
    if (this.invoice) {
      return this.processFacturationWithInvoice();
    }

    //Facturation depuis le controle de factu
    return this.processFacturation().pipe(
      catchError((error) => this.handleFacturationError(error))
    );
  }


  private handleFacturationError(error: any): Observable<never> {
    if (this.canValidate) {
      console.error('Erreur lors du process de facturation:', error);
      this.erreurFacturation = true;
      this.tarificationTerminee = true;
      this.facturationTerminee = true;
      this.messageErreur =
        error?.error?.message || error?.error?.error || error.message;
      this.titreErreur = "Une erreur est survenue";
    } else {
      this.terminalError = !this.terminal?.terminalConnected;
      this.cpsError = !this.terminal?.cpsInserted;
      this.vitaleError = !this.terminal?.vitaleInserted;
    }

    this.facturationEnCours = false;
    this.detectChanges();
    return EMPTY;
  }

  public setCardAbsent(isCVAbsente: boolean) {
    if (isCVAbsente) {
      this.carteVitaleAbsente = true;
    } else {
      this.carteCPSAbsente = true;
    }
    this.detectChanges();
  }


  public setNoLecteur() {
    this.noLecteur = true;
    this.detectChanges();
    this.facturerPapier();

  }

  public setCVAbsente(): void {
    this.setCardAbsent(true);

    if (!this.cpsError || this.carteCPSAbsente) {
      this.initEtatFacturationSansCV();

      const facturation$ = this.getFluxFacturation();
      facturation$.subscribe();
    }
  }

  private initEtatFacturationSansCV(): void {
    this.canValidate = true;
    this.isReady = true;
    this.erreurLecteurSCE = false;
    this.erreurFacturation = false;
    this.tarificationTerminee = false;
    this.facturationTerminee = false;
    this.facturationEnCours = true;
    this.securisationTerminee = false;
    this.noSecurisation = true;
    this.messageErreur = "";
    this.detectChanges();
  }

  public setCPSAbsente() {
    this.setCardAbsent(false);
  }

  private async downloadPdfAsync(poInvoice: Invoice, poFsp: IFspItem): Promise<void> {
    const lsInvoicePdfName = `Facture n°${poInvoice.invoiceNumber} - ${poFsp.name}.pdf`;
    if (this.isMobile) {
      const lsPath = `Download/${lsInvoicePdfName}`;

      const lsUri = await this.svcFilesystem.createFileAsync(lsPath, poFsp.blob, Directory.ExternalStorage, true);
      await this.ioFileOpener.open(lsUri, "application/pdf");
    }
    else
      FileHelper.downloadBlob(poFsp.blob, lsInvoicePdfName);
  }

  public handelOpenFsp(event: Event) {
    this.svcDrawerPopover.open(
      "Choix de l'impression",
      "auto",
      event.currentTarget,
      ConfirmationImpressionComponent,
      {
        withCerfa: () => {
          this.printFsp(true);
        },
        withOutCerfa: () => {
          this.printFsp(false);
        },
        onCancel: () => this.closeMenu(),
        fileName: ECerfa.fsp
      },
      () => (this.showPopover = false)
    );
  }

  closeMenu(): void {
    this.showPopover = false;
    this.svcDrawerPopover.close();
  }

  public async printFsp(withCerfa: boolean): Promise<void> {
    try {
      // Assure que la méthode attendue est asynchrone et renvoie une Map<Invoice, IFspItem[]>
      const fsps = await this.svcFacturation.displayFspAnakin([this.invoice], withCerfa);

      // Récupére la valeur de la Map correspondant à l'Invoice, qui est un tableau
      const fspItems = Array.from(fsps.entries()).find(([invoice]) => invoice._id === this.invoice._id)?.[1] || null;

      if (fspItems && fspItems.length > 0) {
        // Utilise le premier élément du tableau
        const fsp: IFspItem = fspItems[0];

        // Télécharge et ouvre le PDF correspondant
        await this.downloadPdfAsync(this.invoice, fsp);
        this.closeMenu()
      } else {
        console.error("Aucune FSP trouvé pour cette facture.");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération ou du traitement des FSP : ", error);
    }
  }

  async printInvoice() {
    await this.svcFacturation.exportInvoicePdfAnakin(this.invoice, this.isMobile)
  }

  private majFacture(invoice: Invoice) {
    if (invoice) {
      this.invoice = invoice;
    }
  }

  private verifierErreurSV(invoice: Invoice): Observable<Invoice | never> {
    if (!invoice) return EMPTY;

    if (invoice.status.value === EInvoiceStatus.priced && ArrayHelper.hasElements(invoice.erreurSv)) {
      const erreurSV: string = invoice.erreurSv
        .map((error: IFsvErrorSV) => `${error.bloquant ? "Bloquant : " : "Non bloquant : "}${error.code === 'FLF7' ? 'Erreur FLF7 : Vous tentez de facturer trop d\'actes et/ou trop de séances pour cette période.Pour respecter les limites réglementaires, veuillez réduire la période de facturation et essayer à nouveau.' : error.libelle}.`)
        .join();
      this.facturationTerminee = true;
      this.erreurFacturation = true;
      this.messageErreur = erreurSV;
      this.titreErreur = "Une erreur SV est survenue";
      this.detectChanges();
      //Rollback des élements créé jusqu'à l'erreur

      this.svcFacturation.annulerFacture(this.patient._id, this.invoice, this.seancesAFacturer, true)
        .catch(error => {
          console.error("Erreur lors du rollback:", error);
        });

      // Si des erreurs bloquantes existent, arrête le flux en renvoyant EMPTY
      return EMPTY;
    }

    // Continue le flux avec la facture
    return of(invoice);
  }

  private validateAndBillPrestations(): Observable<IdlPrestation[]> {
    if (!this.ordonnance) {
      throw new Error("Le traitement a été supprimé")
    }

    return this.svcActes.hasAccordPrealable(this.ordonnance.actes).pipe(
      mergeMap((hasAccordPrealable: boolean) => {
        if (!hasAccordPrealable) {
          return this.generatePrestationFromSeance(this.seancesAFacturer);
        } else {
          return this.svcAccordPrealable.get(this.ordonnance._id).pipe(
            switchMap((accord: IAccordPrealable) => {
              // Vérification de l'accord préalable
              if (!accord.dateResultat && !accord.resultat) {
                throw new Error("L'accord préalable en lien avec le traitement est incomplet.")
              } else {
                // Accord préalable complet, génération des prestations
                return this.generatePrestationFromSeance(this.seancesAFacturer);
              }
            }),
            catchError((error: Error) => {
              throw new Error("Erreur lors de la récupération de l'accord préalable.")
            })
          );
        }
      }),
      takeUntil(this.destroyed$)
    );
  }


  private generatePrestationFromSeance(seances: StoredSeance[]): Observable<IdlPrestation[]> {
    if (!ArrayHelper.hasElements(seances)) {
      return of([]);  // Retourne un tableau vide si aucune séance n'est disponible
    }

    const traitement: Traitement = Traitement.createFromData(this.ordonnance);
    //séances à facturer sur la plage donnée
    const seancesValidees: StoredSeance[] = seances.filter(x => x.status === EStatusSeance.done);
    //séances restantes à faire dans tout le traitement
    const seancesAFaire: StoredSeance[] = this.seances.filter(seance => seance.status === EStatusSeance.to_be_done);
    //On regarde s'il reste des séances à facturer dans tout le traitement apres celle des séances que l'on va facturer
    const seancesRestantes: StoredSeance[] = this.seances.filter(seance =>
      !seancesValidees.some(seanceValidee => seanceValidee._id === seance._id) &&
      seance.status !== EStatusSeance.canceled &&
      seance.status !== EStatusSeance.inProgress &&
      seance.status !== EStatusSeance.completed
    );

    let prestationsToSave: IdlPrestation[] = [];

    // Création des prestations pour toutes les séances
    return from(seancesValidees).pipe(
      mergeMap(seance => this.svcSeanceGenerator.createAndSavePrestationOptimise(seance, traitement, prestationsToSave)),
      tap(presta => this.prestations.push(presta)),
      mergeMap(presta =>
        seancesRestantes.length > 0 || seancesAFaire.length > 0
          ? of(presta)
          : this.svcTraitement.modifierStateTraitement(traitement, ETraitementState.termine).pipe(map(() => presta))
      ),
      toArray(), // Regroupe toutes les prestations en un tableau
      catchError((error) => {
        return of([]);  // Retourne un tableau vide en cas d'erreur
      })
    );
  }


  private createInvoice(): Invoice {
    const invoice = this.svcFacturation.createInvoiceFromPrestations(
      this.patient,
      this.prestations,
      this.ordonnance,
      this.couvertureAMO,
      this.couvertureAMC,
      this.couvertureAMCPatient,
      this.titulaireSelected);
    return invoice;
  }

  private facturation(invoiceCopy?: Invoice): Observable<Invoice> {
    //Pas d'export si papier
    // if (this.carteCPSAbsente) return of(null);
    const couvAmo = invoiceCopy ? this.patient.AMO[0] : this.patient.AMO?.find(x => this.svcCouvertures.isEligibleFacturationFromPrestations(x, this.prestations));
    return from(this.svcFacturation.forwardActionAnakin(
      this.patient._id,
      this.invoice,
      this.arePatientAndAMOUpToDate(this.patient, couvAmo),

    )).pipe(
      switchMap((reponseInvoice: Invoice) => {
        if (!reponseInvoice) {
          // Si reponseInvoice est null ou undefined, obtenir l'Invoice via getInvoice
          return from(this.svcFacturation.getInvoice(this.invoice._id).toPromise());
        } else {
          // Sinon, utiliser reponseInvoice directement
          return of(reponseInvoice);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Erreur lors de la facturation:', error);
        this.erreurFacturation = true;
        this.tarificationTerminee = true;
        this.facturationTerminee = true;
        this.messageErreur = error?.error?.message || error?.error?.error || error.message;
        this.titreErreur = "Une erreur est survenue lors de la facturation";
        this.facturationEnCours = false;
        this.detectChanges();
        //Si on a pas d'invoice copy c'est qu'on se trouve dans le controle de factu
        if (!invoiceCopy) {
          //Rollback des élements créé jusqu'à l'erreur
          this.svcFacturation.annulerFacture(this.patient._id, this.invoice, this.seancesAFacturer, true)
            .catch(error => {
              console.error("Erreur lors du rollback:", error);
            });
          return EMPTY;   // Retourner une valeur par défaut ou gérer l'erreur comme nécessaire
        } else {
          //On remonte l'erreur pour que le process de facturation au-dessus catch l'erreur
          throw error;
        }
      })
    );
  }

  private securisation(invoiceCopy?: Invoice): Observable<Invoice> {
    if (this.carteCPSAbsente) return of(null);
    const couvAmo = this.patient.AMO?.find(x => this.svcCouvertures.isEligibleFacturationFromPrestations(x, this.prestations));
    return from(this.svcFacturation.forwardActionAnakin(
      this.patient._id,
      this.invoice,
      this.arePatientAndAMOUpToDate(this.patient, couvAmo),
      this.terminal
    )).pipe(
      switchMap((reponseInvoice: Invoice) => {
        if (!reponseInvoice) {
          // Si reponseInvoice est null ou undefined, obtenir l'Invoice via getInvoice
          return from(this.svcFacturation.getInvoice(this.invoice._id).toPromise());
        } else {
          // Sinon, utiliser reponseInvoice directement
          return of(reponseInvoice);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // Gérer les erreurs ici
        console.error('Erreur lors de la securisation:', error);
        this.erreurFacturation = true;
        this.tarificationTerminee = true;
        this.facturationTerminee = true;
        this.messageErreur = error?.error?.message || error?.error?.error || error.message;
        this.titreErreur = "Une erreur est survenue lors de la sécurisation";
        this.facturationEnCours = false;
        this.detectChanges();
        if (!invoiceCopy) {
          //Rollback des élements créé jusqu'à l'erreur
          //a la sécurisation une facture a été crée
          this.svcFacturation.annulerFacture(this.patient._id, this.invoice, this.seancesAFacturer)
            .catch(error => {
              console.error("Erreur lors du rollback:", error);
            });
          return EMPTY;   // Retourner une valeur par défaut ou gérer l'erreur comme nécessaire
        } else {
          //On remonte l'erreur pour que le process de facturation au-dessus catch l'erreur
          throw error;
        }
      })
    );

  }

  public arePatientAndAMOUpToDate(poPatient: IPatient, poAMOP: AMOP): boolean {
    if (!poAMOP)
      return false;

    if (this.carteVitaleAbsente)
      return false;

    return !StringHelper.isBlank(poPatient.externalId) && poAMOP.updateMode !== EUpdateMode.manual;
  }

  private tarification(): Observable<Invoice> {
    const couvAmo = this.patient.AMO?.find(x => this.svcCouvertures.isEligibleFacturationFromPrestations(x, this.prestations));
    return from(this.svcFacturation.forwardActionAnakin(
      this.patient._id,
      this.invoice,
      this.arePatientAndAMOUpToDate(this.patient, couvAmo)
    )).pipe(
      switchMap((reponseInvoice: Invoice) => {
        if (!reponseInvoice) {
          // Si reponseInvoice est null ou undefined, obtenir l'Invoice via getInvoice
          return from(this.svcFacturation.getInvoice(this.invoice._id).toPromise());
        } else {
          // Sinon, utiliser reponseInvoice directement
          return of(reponseInvoice);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Erreur lors de la tarification:', error);
        this.erreurFacturation = true;
        this.tarificationTerminee = true;
        this.facturationTerminee = true;
        this.messageErreur = error?.error?.message || error?.error?.error || error.message;
        this.titreErreur = "Une erreur est survenue lors de la tarification";
        this.facturationEnCours = false;
        this.detectChanges();
        //Rollback des élements créé jusqu'à l'erreur
        this.svcFacturation.annulerFacture(this.patient._id, this.invoice, this.seancesAFacturer, true)
          .catch(error => {
            console.error("Erreur lors du rollback:", error);
          });
        return EMPTY;  // Retourner une valeur par défaut ou gérer l'erreur comme nécessaire
      })
    );
  }

  correctionFacturation() {
    this.svcDrawerPopover.close();
    this.svcPanneau.close();
  }
  
  
  public sendCodeCPS(){
    this.pluginSce.setCarrierCode({carrierCode : this.cpsSaisie});
    this.demandeCodeCPS = false;
		this.errorCodeShow = false;
    this.detectChanges()

  }

	public validateCpsSaisie(){
		this.cpsSaisie = FormHelper.validCPSCode(this.cpsSaisie);
    this.detectChanges()
	}

  public onClose() {
    this.svcDrawerPopover.close();
    this.svcPanneau.close();
  }

  private async listenToSceStatus() {
    if (this.sceStatusSubscription) {
      this.sceStatusSubscription.unsubscribe();
      this.sceStatusSubscription = undefined;
    }

    this.sceStatusSubscription = this.svcSceEvent.sceStatus$.pipe(
				filter(Boolean),
				takeUntil(this.destroyed$),
			switchMap((sceStatus: SceStatus) => this.handleSceStatus(sceStatus)),
      catchError(err => {
        console.error('[COMP] SCE status handling error:', err.message);
        this.erreurLecteurSCE = true;
        this.titreErreurSCE = "Aucune lecteur disponible"
        this.messageErreurSCE = "Aucun lecteur n’a été détecté. Vous pouvez procéder à une facturation papier.";
        this.isReady = true;
        this.chargementLecteur = false;
        this.svcLoader.hideLoader();
        this.detectChanges();
        return of(null);
      })
    ).subscribe();
  }

  public handleSceStatus(sceStatus: SceStatus): Observable<SceStatus | void>{
    switch (sceStatus.status) {
      case 'waiting-deviceId':
        this.svcSnackbar.showToast("error", "bottom center", "SCE non utilisable pour le moment. Veuillez enregistrer l'appareil dans Paramétrages > Lecteurs.", null, null, null, "6000");
        return throwError(new Error(`Erreur SCE: ${sceStatus.message ?? "Erreur Inconnue"}`));
      case 'connected':
        console.warn('[COMP] Le SCE est prêt.');
        return from(this.pluginSce.getStatus()).pipe(
          delay(2000),
          switchMap((status: StatusSCEPlugin) => {
            if (status.reader_connected) {
              this.svcLoader.hideLoader();
              this.onReadyLecteur();
              this.selectionTerminal = true;
              return of(sceStatus);
            }
            this.svcLoader.showLoader("Recherche du lecteur Bluetooth en cours ...");
            return from(this.svcLecteurStorage.getLecteurName()).pipe(
              concatMap((lecteurName: string) => {
                if (!lecteurName) {
                  this.svcLoader.hideLoader();
                  this.svcSnackbar.showToast("error", "bottom center", "Aucun lecteur Bluetooth connecté. Veuillez le connecter dans Paramétrages > Lecteurs", null, null, null, "6000");
                  this.isReady = true;
                  this.chargementLecteur = false;
                  this.detectChanges();
                  return EMPTY;
                }
                this.lecteurName = lecteurName;
                return from(this.svcBluetooth.scanForLecteur(this.lecteurName));
              }),
              concatMap((device: BleDevice | null) => {
                if (!device) {
                  this.svcLoader.hideLoader();
                  this.svcSnackbar.showToast("error", "bottom center", "Aucun lecteur Bluetooth détecté. Veuillez soit l'allumer, soit le connecter dans Paramétrages > Lecteurs", null, null, null, "6000");
                  this.isReady = true;
                  this.chargementLecteur = false;
                  this.detectChanges();
                  return EMPTY;
                }
                return from(this.pluginSce.connectToDevice({deviceName: this.lecteurName}));
              })
            );
          })
        );
      case 'waiting-lecteur':
        this.svcLoader.showLoader("Recherche du lecteur Bluetooth en cours ...");
        return of(sceStatus);
      case 'error':
        console.warn('[COMP] Une erreur a été détectée dans le processus SCE.');
        this.svcSnackbar.showToast("error", "bottom center", `Erreur critique avec le lecteur : ${sceStatus.message ?? "Erreur Inconnue"}.`, null, null, null, "6000");
        return throwError(new Error(`Erreur SCE: ${sceStatus.message ?? "Erreur Inconnue"}`));
      case 'waiting-code':
        console.warn('[COMP] Demande du code porteur.');
        this.svcLoader.hideLoader();
        this.demandeCodeCPS = true;
        this.detectChanges();
        return of(sceStatus);
			case 'error-code':
				console.warn('[COMP] Une erreur a été détectée dans le processus SCE : ' + sceStatus.message);
				this.errorCodeShow = true;
				this.demandeCodeCPS = true;
				this.cpsSaisie = "";
				this.svcLoader.hideLoader();
				this.errorCodeMessage = sceStatus.message;
				this.detectChanges();
				return of(sceStatus)
      case 'ready-code':
        console.warn('[COMP] Code porteur déjà saisi, lancement de la facturation...');
        return of(sceStatus);
      case 'ready':
        if (this.selectionTerminal) break;
        console.warn('[COMP] Le lecteur est prêt.');
        return of(sceStatus).pipe(
          delay(2000),
          tap(() => {
            this.svcLoader.hideLoader();
            this.onReadyLecteur();
            this.selectionTerminal = true;
            this.detectChanges();
          }),
        );
      case 'warning':
        console.warn('[COMP] Une erreur a été détectée dans le processus SCE : ' + sceStatus.message);
        return of(sceStatus);
    }
    this.detectChanges();
    return of(sceStatus);
  }
}
